import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["stateSelect", "issueCheckbox", "results",
                    "licensingBoard", "doiFraud", "nationalResources",
                    "pahjLink"]

  route() {
    const state = this.stateSelectTarget.value
    if (!state) return

    const issues = this.issueCheckboxTargets
      .filter(cb => cb.checked)
      .map(cb => cb.value)

    if (issues.length === 0) return

    const showLicensing = issues.some(i =>
      ["unlicensed", "no_permits", "property_damage",
       "incomplete_work", "substandard_materials", "storm_chaser"].includes(i))

    const showDOI = issues.some(i =>
      ["pressured_aob", "fraudulent_claim", "unlicensed_pa",
       "deductible_waiver"].includes(i))

    const showPAHJ = issues.includes("unlicensed_pa")

    if (this.hasLicensingBoardTarget) {
      this.licensingBoardTarget.classList.toggle("hidden", !showLicensing)
    }
    if (this.hasDoiFraudTarget) {
      this.doiFraudTarget.classList.toggle("hidden", !showDOI)
    }
    if (this.hasPahjLinkTarget) {
      this.pahjLinkTarget.classList.toggle("hidden", !showPAHJ)
    }

    // Show state-specific data
    this.resultsTarget.querySelectorAll("[data-state]").forEach(el =>
      el.classList.toggle("hidden", el.dataset.state !== state))

    this.resultsTarget.classList.remove("hidden")
  }
}
